var d;
var f;
module.exports = function (j, k, q, w) {
  var x = this;
  if (q) {
    d = require("./weapons.js");
    f = require("./store.js");
  }
  this.textures = [
    {
      name: "WALL",
      src: "wall_0",
    },
    {
      name: "DIRT",
      src: "dirt_0",
    },
    {
      name: "FLOOR",
      src: "floor_0",
    },
    {
      name: "GRID",
      src: "grid_0",
    },
    {
      name: "GREY",
      src: "grey_0",
    },
    {
      name: "DEFAULT",
      src: "default",
    },
    {
      name: "ROOF",
      src: "roof_0",
    },
    {
      name: "FLAG",
      src: "flag_0",
    },
    {
      name: "GRASS",
      src: "grass_1",
    },
    {
      name: "CHECK",
      src: "check_0",
    },
    {
      name: "LINES",
      src: "lines_0",
    },
    {
      name: "BRICK",
      src: "brick_0",
    },
    {
      name: "LINK",
      src: "link_0",
      trans: true,
    },
    {
      name: "LIQUID",
      src: "liquid_0",
      trans: true,
    },
    {
      name: "GRAIN",
      src: "grain_0",
    },
    {
      name: "FABRIC",
      src: "fabric_0",
    },
    {
      name: "TILE",
      src: "tile_0",
    },
  ];
  this.getTextureIdByName = function (E) {
    E = E.toUpperCase();
    for (var F = 0; F < this.textures.length; F++) {
      if (this.textures[F].name == E) {
        return F;
      }
    }
    return 0;
  };
  this.getTextureByName = function (E) {
    E = E.toUpperCase();
    for (var F = 0; F < this.textures.length; F++) {
      if (this.textures[F].name == E) {
        return this.textures[F];
      }
    }
    return null;
  };
  this.textureExist = function (E) {
    E = E.toUpperCase();
    for (var F = 0; F < this.textures.length; F++) {
      if (this.textures[F].name == E) {
        return true;
      }
    }
    return false;
  };
  this.prefabs = [
    {
      name: "CUBE",
      src: "cube_0",
      genGeo: async (E, F) => x.generateCube(E, F),
      editFaces: true,
      editFog: true,
      movingTexture: true,
      defaultSize: [10, 10, 10],
      hasHealth: true,
      scalable: true,
      editAmb: true,
      scaleWithSize: false,
      editColor: true,
      editEmissive: true,
      editOpac: true,
      hideBoundingBox: false,
      editPen: true,
      texturable: true,
      assetTextures: true,
      castShadow: true,
      receiveShadow: true,
      hasBorder: true,
      canInterface: true,
      canStretch: true,
      canBeDynamic: true,
      canWallJump: true,
    },
    {
      name: "CRATE",
      src: "cube_0",
      scale: 6,
      isProp: true,
      gen: (E) =>
        x.loadObj(
          E,
          "models/crate_0.obj",
          "textures/crate_0.png",
          E.mSize || this.scale,
          E.color,
          "mesh",
        ),
      hasHealth: true,
      editColor: true,
      editOpac: true,
      dontRound: true,
      // castShadow: true,
      // receiveShadow: true,
      castShadow: true,
      receiveShadow: true,
      canInterface: true,
      canWallJump: true,
    },
    {
      name: "BARREL",
      src: "cube_0",
      scale: 4,
      mlt: 1,
      isProp: true,
      CP: -1,
      gen: (E) =>
        x.loadObj(
          E,
          "models/barrel_0.obj",
          "textures/barrel_0.png",
          E.mSize || this.scale,
          E.color,
          "mesh",
        ),
      hasHealth: true,
      editColor: true,
      editOpac: true,
      dontRound: true,
      castShadow: true,
      receiveShadow: true,
      canInterface: true,
      canWallJump: true,
    },
    {
      name: "LADDER",
      src: "cube_0",
      scale: 0.5,
      width: 3.2,
      genGeo: async (E) => x.generateLadder(E, E.direction),
      notTechnical: true,
      defaultSize: [2, 10, 4],
      scalable: true,
      scaleWithSize: false,
      editColor: true,
      editEmissive: true,
      hideBoundingBox: false,
      editOpac: true,
      texturable: true,
      assetTextures: true,
      customDirection: true,
      castShadow: true,
      receiveShadow: true,
      canStretch: true,
    },
    {
      name: "PLANE",
      src: "cube_0",
      genGeo: async (E) => x.generatePlane(E, E.size[0], E.size[2]),
      hasHealth: true,
      defaultSize: [4, 0.01, 4],
      movingTexture: true,
      dontRound: true,
      scalable: true,
      canTerrain: true,
      edgeNoise: true,
      scaleWithSize: true,
      editColor: true,
      editPen: true,
      editEmissive: true,
      editOpac: true,
      hideBoundingBox: false,
      texturable: true,
      assetTextures: true,
      castShadow: true,
      receiveShadow: true,
      doubleSide: true,
      canInterface: true,
      canStretch: true,
      canWallJump: true,
    },
    {
      name: "SPAWN_POINT",
      src: "cube_0",
      genGeo: async (E, F) => x.generateSpawn(E, F),
      notTechnical: true,
      notStyleable: true,
      scalable: false,
      alwaysSee: true,
      tool: true,
      scaleWithSize: false,
      teamable: true,
      noTexture: true,
      opacity: 0.00001,
      customDirection: true,
      dontRound: true,
    },
    {
      name: "CAMERA_POSITION",
      src: "cube_0",
      editorGen: (E) => x.generateSprite(E, "img/crosshair.png", 5),
      notTechnical: true,
      notStyleable: true,
      defaultSize: [2, 2, 2],
      scalable: false,
      alwaysSee: true,
      tool: true,
      scaleWithSize: false,
    },
    {
      name: "VEHICLE",
      src: "cube_0",
      scale: 20,
      gen: (E) =>
        x.loadObj(
          E,
          "models/vehicle_0.obj",
          "textures/vehicle_0.png",
          E.mSize || this.scale,
          E.color,
          "mesh",
        ),
      hasHealth: true,
      editColor: true,
      editOpac: true,
      dontRound: true,
      complex: true,
      emiss: true,
      castShadow: true,
      receiveShadow: true,
      canInterface: true,
      canWallJump: true,
    },
    {
      name: "STACK",
      src: "cube_0",
      scale: 6,
      isProp: true,
      gen: (E) =>
        x.loadObj(
          E,
          "models/stack_0.obj",
          "textures/stack_0.png",
          E.mSize || this.scale,
          E.color,
          "mesh",
        ),
      hasHealth: true,
      editColor: true,
      editOpac: true,
      dontRound: true,
      castShadow: true,
      receiveShadow: true,
      canInterface: true,
      canWallJump: true,
    },
    {
      name: "RAMP",
      src: "cube_0",
      genGeo: async (E) => x.generateRamp(E, E.direction),
      notTechnical: true,
      defaultSize: [10, 5, 10],
      movingTexture: true,
      scalable: true,
      scaleWithSize: false,
      hideBoundingBox: false,
      boostable: true,
      editColor: true,
      editEmissive: true,
      texturable: true,
      assetTextures: true,
      shootable: true,
      customDirection: true,
      castShadow: true,
      receiveShadow: true,
      doubleSide: true,
      editOpac: true,
      canStretch: true,
    },
    {
      name: "SCORE_ZONE",
      src: "cube_0",
      genGeo: async (E, F) => x.generateCube(E, F),
      notStyleable: true,
      customScore: true,
      defaultSize: [10, 10, 10],
      scalable: true,
      noTexture: true,
      opacity: 0.3,
      lineCol: 16776960,
      tool: true,
    },
    {
      name: "BILLBOARD",
      src: "cube_0",
      genGeo: async (E) => x.generateBillboard(0, 0, 0, ...E.size),
      hasHealth: true,
      defaultSize: [40, 0.01, 10],
      lineCol: 16776960,
      dontRound: true,
      scalable: true,
      canTerrain: true,
      scaleWithSize: true,
      hideBoundingBox: false,
      castShadow: true,
      receiveShadow: true,
      doubleSide: true,
      canInterface: true,
      canWallJump: true,
    },
    {
      name: "DEATH_ZONE",
      src: "cube_0",
      genGeo: async (E, F) => x.generateCube(E, F),
      notTechnical: true,
      notStyleable: true,
      defaultSize: [10, 10, 10],
      scalable: true,
      noTexture: true,
      opacity: 0.3,
      lineCol: 16711680,
      tool: true,
    },
    {
      name: "PARTICLES",
      src: "cube_0",
      genGeo: async (E, F) => x.generateCube(E, F),
      customDirection: true,
      notTechnical: true,
      defaultSize: [20, 20, 20],
      editColor: true,
      scalable: true,
      noTexture: true,
      opacity: 0.3,
      lineCol: 3080191,
      tool: true,
    },
    {
      name: "OBJECTIVE",
      src: "cube_0",
      genGeo: async (E, F) => x.generateCube(E, F),
      objectiveLink: true,
      notTechnical: true,
      notStyleable: true,
      defaultSize: [50, 50, 50],
      scalable: true,
      noTexture: true,
      opacity: 0.2,
      lineCol: 13107455,
      tool: true,
    },
    {
      name: "TREE",
      src: "cube_0",
      scale: 10,
      gen: (E) =>
        x.loadObj(
          E,
          "models/tree_0.obj",
          "textures/tree_0.png",
          E.mSize || this.scale,
          E.color,
          "mesh",
        ),
      hasHealth: true,
      editColor: true,
      editOpac: true,
      dontRound: true,
      complex: true,
      castShadow: true,
      receiveShadow: true,
      canInterface: true,
      canWallJump: true,
    },
    {
      name: "CONE",
      src: "cube_0",
      scale: 4,
      isProp: true,
      CPY: -0.5,
      CP: -2,
      gen: (E) =>
        x.loadObj(
          E,
          "models/cone_0.obj",
          "textures/cone_0.png",
          E.mSize || this.scale,
          E.color,
          "mesh",
        ),
      hasHealth: true,
      editColor: true,
      editOpac: true,
      dontRound: true,
      complex: true,
      castShadow: true,
      receiveShadow: true,
      canInterface: true,
      canWallJump: true,
    },
    {
      name: "CONTAINER",
      src: "cube_0",
      scale: 7,
      gen: (E) =>
        x.loadObj(
          E,
          "models/container_0.obj",
          "textures/container_0.png",
          E.mSize || this.scale,
          E.color,
          "mesh",
        ),
      hasHealth: true,
      editColor: true,
      editOpac: true,
      dontRound: true,
      castShadow: true,
      receiveShadow: true,
      canInterface: true,
      canWallJump: true,
    },
    {
      name: "GRASS",
      src: "cube_0",
      scale: 32,
      gen: (E) =>
        x.loadObj(
          E,
          "models/grass_0.obj",
          "textures/grass_0.png",
          E.mSize || this.scale,
          E.color,
          "mesh",
        ),
      hasHealth: true,
      noDetail: true,
      editColor: true,
      editOpac: true,
      complex: true,
      doubleSide: true,
      transparent: true,
      receiveShadow: true,
      canInterface: true,
      frameT: 180,
      frames: 4,
      alphaTest: 0.02,
    },
    {
      name: "CONTAINERR",
      src: "cube_0",
      scale: 7,
      gen: (E) =>
        x.loadObj(
          E,
          "models/containerr_0.obj",
          "textures/containerr_0.png",
          E.mSize || this.scale,
          E.color,
          "mesh",
        ),
      hasHealth: true,
      editColor: true,
      editOpac: true,
      dontRound: true,
      castShadow: true,
      receiveShadow: true,
      canInterface: true,
      canWallJump: true,
    },
    {
      name: "ACIDBARREL",
      src: "cube_0",
      scale: 4,
      isProp: true,
      gen: (E) =>
        x.loadObj(
          E,
          "models/acidbarrel_0.obj",
          "textures/acidbarrel_0.png",
          E.mSize || this.scale,
          E.color,
          "mesh",
        ),
      hasHealth: true,
      editColor: true,
      editOpac: true,
      dontRound: true,
      emiss: true,
      castShadow: true,
      receiveShadow: true,
      canInterface: true,
      canWallJump: true,
    },
    {
      name: "DOOR",
      src: "cube_0",
      scale: 5,
      gen: (E) =>
        x.loadObj(
          E,
          "models/door_0.obj",
          "textures/door_0.png",
          E.mSize || this.scale,
          E.color,
          "mesh",
        ),
      hasHealth: true,
      editColor: true,
      editOpac: true,
      dontRound: true,
      castShadow: true,
      receiveShadow: true,
      canInterface: true,
      canWallJump: true,
    },
    {
      name: "WINDOW",
      src: "cube_0",
      scale: 6,
      gen: (E) =>
        x.loadObj(
          E,
          "models/window_0.obj",
          "textures/window_0.png",
          E.mSize || this.scale,
          E.color,
          "mesh",
        ),
      noDetail: true,
      hasHealth: true,
      editColor: true,
      editOpac: true,
      dontRound: true,
      castShadow: true,
      transparent: true,
      receiveShadow: true,
      canInterface: true,
      canWallJump: true,
    },
    {
      name: "FLAG",
      src: "cube_0",
      genGeo: async (E, F) => x.generateFlag(E, F),
      notTechnical: true,
      notStyleable: true,
      noDetail: true,
      defaultSize: [j.flagZoneS, j.flagZoneH, j.flagZoneS],
      scalable: false,
      tool: true,
      scaleWithSize: false,
      lineCol: 13107455,
      teamable: true,
      noDefault: true,
    },
    {
      name: "GATE",
      src: "cube_0",
      genGeo: async (E, F) => x.generateCube(E, F),
      canUndo: true,
      interact: true,
      customScore: true,
      movingTexture: true,
      defaultSize: [10, 10, 10],
      scalable: true,
      forceCollision: true,
      editAmb: true,
      scaleWithSize: false,
      editColor: true,
      editEmissive: true,
      editOpac: true,
      teamable: true,
      lineCol: 16711935,
      texturable: true,
      assetTextures: true,
      tool2: true,
      castShadow: true,
      receiveShadow: true,
      complex: true,
      hasBorder: true,
      canInterface: true,
      canWallJump: true,
    },
    {
      name: "CHECK_POINT",
      src: "cube_0",
      genGeo: async (E, F) => x.generateCube(E, F),
      notStyleable: true,
      defaultSize: [10, 10, 10],
      scalable: true,
      teamable: true,
      noTexture: true,
      opacity: 0.3,
      lineCol: 252613,
      tool: true,
      customDirection: true,
    },
    {
      name: "WEAPON_PICKUP",
      src: "cube_0",
      genGeo: async (E, F) => x.generateWeapon(E, F),
      notStyleable: true,
      interact: true,
      customScore: true,
      teamable: true,
      defaultSize: [j.pickupZoneX, j.pickupZoneH, j.pickupZoneZ],
      scalable: false,
      tool: true,
      scaleWithSize: false,
      lineCol: 3595263,
      noTexture: true,
      texturable: false,
      opacity: 0.1,
    },
    {
      name: "TELEPORTER",
      src: "cube_0",
      genGeo: async (E, F) => x.generateCube(E, F),
      notStyleable: true,
      defaultSize: [10, 10, 10],
      teamable: true,
      scalable: true,
      noTexture: true,
      opacity: 0.3,
      lineCol: 11665392,
      tool: true,
      customDirection: true,
      optionalDirection: true,
    },
    {
      name: "TEDDY",
      src: "cube_0",
      scale: 6,
      isProp: true,
      CPY: -3,
      CP: -3.6,
      gen: (E) =>
        x.loadObj(
          E,
          "models/teddy_0.obj",
          "textures/teddy_0.png",
          E.mSize || this.scale,
          E.color,
          "mesh",
        ),
      hasHealth: true,
      noDetail: true,
      editColor: true,
      editOpac: true,
      dontRound: true,
      complex: true,
      castShadow: true,
      receiveShadow: true,
      canInterface: true,
      canWallJump: true,
    },
    {
      name: "TRIGGER",
      src: "cube_0",
      genGeo: async (E, F) => x.generateCube(E, F),
      hasSound: true,
      canTargetInterface: true,
      hasHealth: true,
      movingTexture: true,
      defaultSize: [10, 10, 10],
      scalable: true,
      forceCollision: true,
      editAmb: true,
      scaleWithSize: false,
      editColor: true,
      editEmissive: true,
      editOpac: true,
      teamable: true,
      lineCol: 16711935,
      texturable: true,
      assetTextures: true,
      tool2: true,
      castShadow: true,
      receiveShadow: true,
      complex: true,
      canInterface: true,
      canWallJump: true,
    },
    {
      name: "SIGN",
      src: "cube_0",
      noCol: true,
      genGeo: async (E) => x.generateSign(E, 0, 0, 0, ...E.size),
      notTechnical: true,
      movingTexture: true,
      hasText: true,
      defaultSize: [40, 0.01, 10],
      forceCollision: true,
      lineCol: 16776960,
      scalable: true,
      scaleWithSize: true,
      hideBoundingBox: false,
      tool: true,
      castShadow: true,
      receiveShadow: true,
      doubleSide: true,
    },
    {
      name: "DEPOSIT_BOX",
      src: "cube_0",
      genGeo: async (E, F) => x.generateCube(E, F),
      movingTexture: true,
      defaultSize: [10, 10, 10],
      scalable: true,
      forceCollision: true,
      editAmb: true,
      scaleWithSize: false,
      editColor: true,
      editEmissive: true,
      editOpac: true,
      teamable: true,
      lineCol: 16711935,
      texturable: true,
      assetTextures: true,
      tool2: true,
      castShadow: true,
      receiveShadow: true,
      complex: true,
      hasBorder: true,
      canInterface: true,
      canWallJump: true,
    },
    {
      name: "LIGHT_CONE",
      src: "cube_0",
      noCol: true,
      genGeo: async (E, F) => x.generateCone(...E.size, F),
      notTechnical: true,
      defaultSize: [10, 10, 10],
      movingTexture: true,
      noDetail: true,
      scalable: true,
      noCollision: true,
      scaleWithSize: false,
      editOpac: true,
      editColor: true,
      lineCol: 16711935,
      castShadow: true,
      receiveShadow: true,
      complex: true,
      doubleSide: true,
      blending: 2,
      fakeScale: true,
    },
    {
      name: "SPECTATE_CAM",
      src: "cube_0",
      genGeo: async (E, F) => x.generateCube(E, F),
      objectiveLink: true,
      isCam: true,
      notTechnical: true,
      notStyleable: true,
      defaultSize: [10, 10, 10],
      scalable: false,
      tool: true,
      scaleWithSize: false,
    },
    {
      name: "SPHERE",
      src: "cube_0",
      noCol: true,
      genGeo: async (E, F) => x.generateSphere(...E.size, F),
      editFog: true,
      notTechnical: true,
      movingTexture: true,
      defaultSize: [5, 5, 5],
      scalable: true,
      scaleWithSize: false,
      editColor: true,
      editEmissive: true,
      editOpac: true,
      hideBoundingBox: false,
      noCollision: true,
      texturable: true,
      assetTextures: true,
    },
    {
      name: "PLACEHOLDER",
      src: "cube_0",
      genGeo: async (E, F) => x.generateCube(E, F),
      notStyleable: true,
      defaultSize: [10, 10, 10],
      scalable: true,
      noTexture: true,
      noExport: true,
      tool: true,
      opacity: 0.1,
      lineCol: 0,
    },
    {
      name: "CARDB",
      src: "cube_0",
      scale: 5,
      isProp: true,
      CPY: -2.5,
      CP: -2,
      gen: (E) =>
        x.loadObj(
          E,
          "models/cardb_0.obj",
          "textures/cardb_0.png",
          E.mSize || this.scale,
          E.color,
          "mesh",
        ),
      hasHealth: true,
      editColor: true,
      editOpac: true,
      dontRound: true,
      castShadow: true,
      receiveShadow: true,
      canInterface: true,
      canWallJump: true,
    },
    {
      name: "PALLET",
      src: "cube_0",
      scale: 6,
      isProp: true,
      CPY: -5,
      gen: (E) =>
        x.loadObj(
          E,
          "models/pallet_0.obj",
          "textures/pallet_0.png",
          E.mSize || this.scale,
          E.color,
          "mesh",
        ),
      hasHealth: true,
      editColor: true,
      editOpac: true,
      dontRound: true,
      complex: true,
      castShadow: true,
      receiveShadow: true,
      canInterface: true,
      canWallJump: true,
    },
    {
      name: "LIQUID",
      src: "cube_0",
      noCol: true,
      genGeo: async (E) => x.generateLiquid(E, E.size[0], E.size[2]),
      noCollision: true,
      notTechnical: true,
      defaultSize: [25, 0.01, 25],
      movingTexture: true,
      dontRound: true,
      scalable: true,
      canTerrain: true,
      scaleWithSize: true,
      editColor: true,
      editEmissive: true,
      editOpac: true,
      hideBoundingBox: false,
      texturable: true,
      assetTextures: true,
      castShadow: true,
      receiveShadow: true,
      doubleSide: true,
    },
    {
      name: "SOUND_EMITTER",
      src: "cube_0",
      noCol: true,
      genGeo: async (E, F) => x.generateSphere(...E.size, F),
      hasSound: true,
      notTechnical: true,
      notStyleable: true,
      defaultSize: [5, 5, 5],
      hideBoundingBox: false,
      noCollision: true,
      tool: true,
      wireframe: true,
      assetSounds: true,
    },
    {
      name: "EVENT",
      src: "cube_0",
      scale: 2,
      gen: (E) =>
        x.loadObj(
          E,
          "models/event_0.obj",
          "textures/event_0.png",
          E.mSize || this.scale,
          E.color,
          "mesh",
        ),
      noExport: true,
      localOnly: true,
      editColor: true,
      editOpac: true,
      dontRound: true,
      complex: true,
      castShadow: true,
      receiveShadow: true,
    },
    {
      name: "TERMINAL",
      src: "cube_0",
      genGeo: async (E, F) => x.generateCube(E, F),
      localOnly: true,
      movingTexture: true,
      defaultSize: [10, 10, 10],
      hasHealth: true,
      scalable: true,
      editAmb: true,
      scaleWithSize: false,
      editColor: true,
      editEmissive: true,
      editOpac: true,
      hideBoundingBox: false,
      editPen: true,
      texturable: true,
      assetTextures: true,
      tool2: true,
      interact2: true,
      castShadow: true,
      receiveShadow: true,
      hasBorder: true,
      canInterface: true,
      canWallJump: true,
    },
    {
      name: "PREMIUM_ZONE",
      src: "cube_0",
      genGeo: async (E, F) => x.generateCube(E, F),
      notStyleable: true,
      defaultSize: [10, 10, 10],
      scalable: true,
      noTexture: true,
      opacity: 0.3,
      lineCol: 16498733,
      tool: true,
      hasBorder: true,
    },
    {
      name: "VERIFIED_ZONE",
      src: "cube_0",
      genGeo: async (E, F) => x.generateCube(E, F),
      notStyleable: true,
      defaultSize: [10, 10, 10],
      scalable: true,
      noTexture: true,
      opacity: 0.3,
      lineCol: 4244735,
      tool: true,
      hasBorder: true,
    },
    {
      name: "CUSTOM_ASSET",
      src: "model",
      scale: 1,
      custom: true,
      gen: (E) =>
        x.loadObj(
          E,
          "model.obj",
          "model.png",
          E.mSize || this.scale,
          E.color,
          "mesh",
        ),
      hasHealth: true,
      editColor: true,
      editOpac: true,
      dontRound: true,
      complex: true,
      castShadow: true,
      receiveShadow: true,
      canInterface: true,
      hasSpin: true,
      canWallJump: true,
    },
    {
      name: "BOMB_SITE",
      src: "cube_0",
      genGeo: async (E, F) => x.generateCube(E, F),
      notTechnical: true,
      notStyleable: true,
      defaultSize: [25, 25, 25],
      scalable: true,
      noTexture: true,
      opacity: 0.2,
      lineCol: 9600493,
      tool: true,
    },
    {
      name: "BOOST_PAD",
      src: "cube_0",
      scale: 4,
      genGeo: async (E, F) => x.generatePad(E, F),
      notTechnical: true,
      notStyleable: true,
      defaultSize: [10, 0.5, 10],
      scalable: false,
      tool: true,
      scaleWithSize: false,
      lineCol: 13107455,
      noDefault: true,
      bounce: true,
    },
    {
      name: "TEAM_ZONE",
      src: "cube_0",
      genGeo: async (E, F) => x.generateCube(E, F),
      notStyleable: true,
      defaultSize: [10, 10, 10],
      scalable: true,
      teamable: true,
      noTexture: true,
      opacity: 0.3,
      lineCol: 4244735,
      tool: true,
      hasBorder: true,
    },
    {
      name: "CYLINDER",
      src: "cube_0",
      genGeo: async (E, F) => x.generateCylinder(E, F),
      canInterface: true,
      hasHealth: true,
      movingTexture: true,
      defaultSize: [10, 10, 10],
      scalable: true,
      scaleWithSize: false,
      editColor: true,
      editEmissive: true,
      editOpac: true,
      hideBoundingBox: false,
      texturable: true,
      assetTextures: true,
      castShadow: true,
      receiveShadow: true,
      hasSpin: true,
      fakeScale: true,
      doubleSide: true,
    },
    {
      name: "POLICE",
      src: "police_0",
      scale: 4,
      mlt: 1,
      gen: (E) =>
        x.loadObj(
          E,
          "models/police_0.obj",
          "textures/police_0.png",
          E.mSize || this.scale,
          E.color,
          "mesh",
        ),
      hasHealth: true,
      editColor: true,
      editOpac: true,
      dontRound: true,
      castShadow: true,
      receiveShadow: true,
      canInterface: true,
      canWallJump: true,
    },
    {
      name: "CAGE",
      src: "cage_0",
      scale: 6,
      isProp: true,
      gen: (E) =>
        x.loadObj(
          E,
          "models/cage_0.obj",
          "textures/cage_0.png",
          E.mSize || this.scale,
          E.color,
          "mesh",
        ),
      hasHealth: true,
      editColor: true,
      editOpac: true,
      dontRound: true,
      // castShadow: true,
      // receiveShadow: true,
      castShadow: true,
      receiveShadow: true,
      canInterface: true,
      canWallJump: true,
    },
    {
      name: "EBARREL",
      src: "ebarrel_0",
      scale: 4,
      mlt: 1,
      isProp: true,
      CP: -1,
      gen: (E) =>
        x.loadObj(
          E,
          "models/ebarrel_0.obj",
          "textures/ebarrel_0.png",
          E.mSize || this.scale,
          E.color,
          "mesh",
        ),
      hasHealth: true,
      editColor: true,
      complex: true,
      editOpac: true,
      dontRound: true,
      castShadow: true,
      receiveShadow: true,
      canInterface: true,
      canWallJump: true,
    },
    {
      name: "SHOWCASE",
      src: null,
      scale: 1,
      mlt: 1,
      noCol: true,
      noCollision: true,
      gen: (E) => x.loadItem(E),
      editColor: true,
      complex: true,
      editOpac: true,
      dontRound: true,
      castShadow: true,
      receiveShadow: true,
    },
    {
      name: "POINT_LIGHT",
      src: "cube_0",
      noCol: true,
      genGeo: async (E, F) => x.generatePointLight(...E.size, F),
      notTechnical: true,
      noTexture: true,
      wireframe: true,
      tool: true,
      defaultSize: [5, 5, 5],
      editColor: true,
      hideBoundingBox: false,
      noCollision: true,
      light: true,
      noDetail: true,
    },
    {
      name: "GHOST",
      src: "ghost_0",
      scale: 4,
      isProp: true,
      gen: (E) =>
        x.loadObj(
          E,
          "models/ghost_0.obj",
          "textures/ghost_0.png",
          E.mSize || this.scale,
          E.color,
          "mesh",
        ),
      hasHealth: true,
      editColor: true,
      editOpac: true,
      dontRound: true,
      emiss: true,
      castShadow: true,
      receiveShadow: true,
      canInterface: true,
      canWallJump: true,
    },
    {
      name: "BOT",
      src: "cube_0",
      ai: true,
      scale: 4,
      gen: (E) =>
        x.loadObj(
          E,
          "models/ghost_0.obj",
          "textures/ghost_0.png",
          E.mSize || this.scale,
          E.color,
          "mesh",
        ),
      hasHealth: true,
      editColor: true,
      dontRound: true,
      complex: true,
      castShadow: true,
      receiveShadow: true,
      transparent: true,
      customScore: true,
      canInterface: true,
      canTargetInterface: true,
    },
    {
      name: "PUMPKIN",
      src: "pumpkin_0",
      scale: 4,
      mlt: 1,
      isProp: true,
      gen: (E) =>
        x.loadObj(
          E,
          "models/pumpkin_0.obj",
          "textures/pumpkin_0.png",
          E.mSize || this.scale,
          E.color,
          "mesh",
        ),
      emiss: true,
      hasHealth: true,
      editColor: true,
      editOpac: true,
      dontRound: true,
      castShadow: true,
      receiveShadow: true,
      canInterface: true,
      canWallJump: true,
    },
    {
      name: "RUNE",
      src: "rune_0",
      noCol: true,
      genGeo: async (E) => x.generateRune(E, E.size[0], E.size[2]),
      defaultSize: [20, 0.01, 20],
      notTechnical: true,
      movingTexture: true,
      scalable: true,
      noCollision: true,
      scaleWithSize: true,
      editOpac: true,
      editColor: true,
      editEmissive: true,
      lineCol: 16711935,
      castShadow: false,
      receiveShadow: true,
      complex: true,
      doubleSide: true,
      fakeScale: true,
      alphaTest: 0.9,
      canWallJump: true,
    },
    {
      name: "SKELETON",
      src: "skeleton_0",
      scale: 4,
      mlt: 1,
      isProp: true,
      gen: (E) =>
        x.loadObj(
          E,
          "models/skeleton_0.obj",
          "textures/skeleton_0.png",
          E.mSize || this.scale,
          E.color,
          "mesh",
        ),
      hasHealth: true,
      editColor: true,
      editOpac: true,
      dontRound: true,
      castShadow: true,
      receiveShadow: true,
      canInterface: true,
      canWallJump: true,
    },
    {
      name: "KNIGHT",
      src: "knight_0",
      scale: 4,
      mlt: 1,
      isProp: true,
      gen: (E) =>
        x.loadObj(
          E,
          "models/knight_0.obj",
          "textures/knight_0.png",
          E.mSize || this.scale,
          E.color,
          "mesh",
        ),
      hasHealth: true,
      editColor: true,
      editOpac: true,
      dontRound: true,
      castShadow: true,
      receiveShadow: true,
      canInterface: true,
      canWallJump: true,
    },
  ];
  for (var z = 0; z < this.prefabs.length; z++) {
    this.prefabs[z].id = z;
  }
  this.getPrefabIdByName = function (E) {
    E = E.toUpperCase();
    for (var F = 0; F < this.prefabs.length; F++) {
      if (this.prefabs[F].name == E) {
        return F;
      }
    }
    return 0;
  };
  this.getPrefabByName = function (E) {
    E = E.toUpperCase();
    for (var F = 0; F < this.prefabs.length; F++) {
      if (this.prefabs[F].name == E) {
        return this.prefabs[F];
      }
    }
    return null;
  };
  this.prefabExist = function (E) {
    E = E.toUpperCase();
    for (var F = 0; F < this.prefabs.length; F++) {
      if (this.prefabs[F].name == E) {
        return true;
      }
    }
    return false;
  };
  if (q) {
    let E = new q.TextureLoader();
    let F = new q.LoadingManager();
    let G = new q.OBJLoader(F);
    let H = new q.GLTFLoader(F);
    window.loadedGeos = [];
    this.createMesh = function (N, O, P, Q, R, S, T, U, V, W) {
      var X;
      if (P) {
        X = E.load(k[W ? "userAssetsUrl" : "assetsUrl"](P), (a0) => {
          a0.wrapS = q.RepeatWrapping;
          a0.wrapT = q.RepeatWrapping;
          a0.repeat.set(1, 1);
          a0.repeat.set(
            N.prefab.frames ? 1 / N.prefab.frames : N.prefab.repeatX || 1,
            N.prefab.repeatY || 1,
          );
          a0.minFilter = q.NearestFilter;
          a0.magFilter = q.NearestFilter;
          a0.needsUpdate = true;
        });
      }
      var Y = new q.StrippedLambertMaterial({
        map: X,
        vertexColors: q.VertexColors,
        color: R || 16777215,
        shininess: 60,
        specular: 2697513,
        alphaTest:
          W && N.assetID.includes("a") ? 0.02 : N.prefab.alphaTest || 0,
      });
      if (W) {
        O.computeBoundingBox();
        S = -O.boundingBox.getCenter().y * Q;
      }
      O.computeFaceNormals();
      O.computeVertexNormals();
      var Z = new q.Mesh(O, Y);
      Z.scale.setScalar(Q || 1);
      Z.position.y += S;
      Z.rotateX(T || 0);
      Z.rotateY(U || 0);
      if (V) {
        if (N[V]) {
          N.remove(N[V]);
          N[V] = null;
        }
        N[V] = Z;
        N.add(N[V]);
      } else {
        N.add(Z);
      }
      return Z;
    };
    this.loadObj = function (N, O, P, Q, R, S = null, T = 0, U = 0, V = 0) {
      return new Promise((resolve) => {
        var X = N.assetID && N.assetID.length;
        var Y = null;
        var Z = "obj";
        if (X) {
          var a0 = N.assetID.replace(/[^\d]/g, "");
          if (N.assetID.includes("g")) {
            Z = "gltf";
          }
          O = a0 + "/model." + Z;
          P = a0 + "/model.png";
          Y = function (a2) {
            KE.updateProgress(((a2.loaded / a2.total) * 100).round(0));
          };
        }
        var a1 = window.loadedGeos[O + Z];
        if (a1) {
          resolve(x.createMesh(N, a1, P, Q, R, T, U, V, S, X));
        } else {
          a1 = new q.BufferGeometry();
          (Z == "gltf" ? H : G).load(
            k[X ? "userAssetsUrl" : "assetsUrl"](O),
            (a2) => {
              if (a2.scene) {
                a2 = a2.scene;
              }
              if (a2.children.length > 1) {
                var a3 = new q.Geometry();
                for (var a4 = 0; a4 < a2.children.length; ++a4) {
                  a2.children[a4].updateMatrix();
                  a3.merge(
                    new q.Geometry().fromBufferGeometry(
                      a2.children[a4].geometry,
                    ),
                    a2.children[a4].matrix,
                    a4,
                  );
                }
                a3.groupsNeedUpdate = true;
                a1.copy(new q.BufferGeometry().fromGeometry(a3));
              } else {
                a1.copy(a2.children[0].geometry);
              }
              window.loadedGeos[O + Z] = a1;
              resolve(x.createMesh(N, a1, P, Q, R, T, U, V, S, X));
            },
            Y,
          );
        }
      });
    };
    this.loadItem = function (N) {
      var O = f.skins[N.itemID || 0];
      if (!O.type) {
        f.previews[O.weapon];
      }
      var P = d[O.weapon - 1] || {};
      var Q =
        f.types[O.type || 0] +
        (O.type ? O.id : O.weapon) +
        (O.mid == null ? "" : "_" + O.mid);
      var R =
        O.mid == null
          ? O.type && O.type == 3
            ? O.pat
              ? O.tex
              : "melee/melee_" + (O.id || 0) + (O.tex ? "_" + O.tex : "")
            : O.type
              ? O.tex
                ? f.types[O.type || 0] + O.id + "_" + O.tex
                : null
              : O.tex
                ? O.tex
                : "weapons/skins/weapon_" + O.weapon + "_" + O.id
          : k.getReModel(f, O);
      return this.loadObj(
        N,
        "models/" + Q + ".obj",
        "textures/" + (R || Q) + ".png",
        (N.mSize || 1) * (O.mScl || P.scale || 1),
        N.color,
        "mesh",
      );
    };
    new q.BoxBufferGeometry(1, 1, 1);
    new q.PlaneBufferGeometry(1, 1).rotateX(-Math.PI / 2);
    new q.StrippedLambertMaterial({
      color: 65280,
    });
    new q.StrippedLambertMaterial({
      color: 5592405,
    });
    this.generateSprite = function (N, O, P) {
      let Q = new q.TextureLoader().load(O);
      Q.magFilter = q.NearestFilter;
      let R = new q.SpriteMaterial({
        map: Q,
        color: 16777215,
      });
      let S = new q.Sprite(R);
      if (P) {
        S.scale.set(P, P, 1);
      }
      N.add(S);
    };
    this.generateEmbed = function () {};
    this.generatePlane = function (N, O, P) {
      var Q = w.generatePlane(
        P,
        O,
        {
          scale: N.texStretch ? 0 : 1,
        },
        0,
        0,
        0,
      );
      (Q = new q.BufferGeometry().fromGeometry(Q)).scale(O, P, 1);
      Q.rotateX(-Math.PI / 2);
      return Q;
    };
    this.generateRune = function (N, O, P) {
      var Q = w.generatePlane(
        P,
        O,
        {
          scale: 0,
        },
        0,
        0,
        0,
      );
      (Q = new q.BufferGeometry().fromGeometry(Q)).scale(O, P, 1);
      Q.rotateX(-Math.PI / 2);
      return Q;
    };
    this.generateLiquid = function (N, O, P) {
      var Q = w.generatePlane(
        P,
        O,
        {
          scale: 1,
          tilesX: N.tilesX || 10,
          tilesZ: N.tilesZ || 10,
        },
        0,
        0,
        0,
      );
      (Q = new q.Geometry().copy(Q)).scale(O, P, 1);
      Q.rotateX(-Math.PI / 2);
      return Q;
    };
    this.generateCube = function (N, O) {
      var [P, Q, R] = N.size;
      var S = w.generateCube(N.faces || [1, 1, 1, 1, 1, 1], P, Q, R, {
        scale: N.texStretch ? 0 : 1,
        amb: O,
      });
      (S = new q.BufferGeometry().fromGeometry(S)).scale(P, Q, R);
      S.translate(0, -Q / 2, 0);
      return S;
    };
    this.generateSphere = function (N, O, P, Q) {
      var R = w.generateSphere(N, O, P, {
        scale: 1,
        amb: Q,
        useScale: true,
      });
      return (R = new q.BufferGeometry().fromGeometry(R));
    };
    this.generatePointLight = function (N, O, P, Q) {
      var R = w.generateSphere(N, O, P, {
        scale: 1,
        amb: Q,
        useScale: true,
      });
      return (R = new q.BufferGeometry().fromGeometry(R));
    };
    this.generateCone = function (N, O, P) {
      var Q = w.generateCone(O, {
        scale: 1,
        useScale: true,
      });
      var R = new q.Mesh(Q);
      var S = Math.min(N, P) / 2;
      R.scale.set(S, O, S);
      R.updateMatrix();
      var T = new q.Geometry();
      T.merge(R.geometry, R.matrix);
      return (T = new q.BufferGeometry().fromGeometry(T));
    };
    this.generateCylinder = function (N) {
      var [O, P, Q] = N.size;
      var R = w.generateCylinder({
        scale: 1,
        useScale: true,
        open: !!N.openEnded,
      });
      var S = new q.Mesh(R);
      var T = Math.min(O, Q) / 2;
      S.scale.set(T, P, T);
      S.updateMatrix();
      var U = new q.Geometry();
      U.merge(S.geometry, S.matrix);
      return (U = new q.BufferGeometry().fromGeometry(U));
    };
    this.generateRamp = function (N, O) {
      var P;
      var [Q, R, S] = N.size;
      var T = new q.Geometry();
      P = 0 - R / 2;
      var U = (O = (O * Math.PI) / 2) != 0 && O != Math.PI;
      ((V, W, X, Y, Z, a0, a1, a2, a3) => {
        a2 = a2 || {};
        var a4 = new q.Mesh(w.generatePlane(a0 * 2, Y, a2));
        a4.position.set(V, W + Z / 2, X);
        a0 *= 2;
        var a5 = Math.sqrt(Z * Z + a0 * a0);
        a4.scale.set(Y, a5, 2);
        a4.rotateY(-Math.PI / 2 - a1);
        a4.rotateX(Math.asin(Z / a5) - Math.PI / 2);
        a4.rotateZ(a3 || 0);
        a4.updateMatrix();
        T.merge(a4.geometry, a4.matrix);
      })(0, P, 0, U ? Q : S, R, (U ? S : Q) / 2, O, {
        scale: N.texStretch ? 0 : 1,
      });
      return T;
    };
    let I = (N, O, P, Q, R, S, T, U, V, W) => {
      (T = T || {}).premultipliedAlpha = true;
      var X = new q.Mesh(w.generatePlane(S, R, T, O, P, Q));
      X.position.set(O, P, Q);
      X.rotateY(U || 0);
      X.rotateX((V || 0) - Math.PI / 2);
      X.rotateZ(W || 0);
      X.scale.set(R * 2, S * 2, 1);
      X.updateMatrix();
      N.merge(X.geometry, X.matrix);
    };
    let J = (N, O, P, Q, R, S, T, U, V) => {
      V = V || {};
      var W = new q.Mesh(w.generateCube(U, R, S, T, V));
      W.position.set(O, P, Q);
      W.rotation.set(V.yR || 0, V.xR || 0, V.zR || 0);
      W.scale.set(R, S, T);
      if (N instanceof q.Geometry) {
        W.updateMatrix();
        N.merge(W.geometry, W.matrix);
      } else {
        N.add(W);
      }
      return W;
    };
    let K = (N, O, P, Q, R, S, T, U) => {
      U = U || {};
      var V = new q.Mesh(w.generateSphere(R, S, T, U));
      V.position.set(O, P + S / 2, Q);
      V.rotation.set(U.yR || 0, U.xR || 0, U.zR || 0);
      V.scale.set(R / 2, S / 2, T / 2);
      if (N instanceof q.Geometry) {
        V.updateMatrix();
        N.merge(V.geometry, V.matrix);
      } else {
        N.add(V);
      }
      return V;
    };
    let L = (N, O, P, Q, R, S, T, U) => {
      U = U || {};
      var V = new q.Mesh(w.generateCylinder(U));
      var W = Math.min(R, T) / 2;
      V.scale.set(W, S, W);
      V.position.set(O, P, Q);
      V.rotation.set(U.yR || 0, U.xR || 0, U.zR || 0);
      if (N instanceof q.Geometry) {
        V.updateMatrix();
        N.merge(V.geometry, V.matrix);
      } else {
        N.add(V);
      }
      return V;
    };
    this.generateLadder = function (N, O) {
      var [P, Q, R] = N.size;
      var S = new q.Geometry();
      O = (O * Math.PI) / 2;
      let T = {
        x: 0 + j.ladderScale * Math.cos(O),
        z: 0 + j.ladderScale * Math.sin(O),
        y: 0 - Q / 2,
      };
      J(
        S,
        T.x + j.ladderWidth * Math.sin(O),
        T.y,
        T.z + j.ladderWidth * Math.cos(O),
        j.ladderScale * 2,
        Q + 2,
        j.ladderScale * 2,
        [1, 1, 1, 1, 1, 1],
        {
          scale: N.texStretch ? 1 : 0.02,
        },
      );
      J(
        S,
        T.x - j.ladderWidth * Math.sin(O),
        T.y,
        T.z - j.ladderWidth * Math.cos(O),
        j.ladderScale * 2,
        Q + 2,
        j.ladderScale * 2,
        [1, 1, 1, 1, 1, 1],
        {
          scale: N.texStretch ? 1 : 0.02,
        },
      );
      for (var U = Math.floor(Q / 6), V = 0; V < U; ++V) {
        I(
          S,
          T.x,
          T.y + (V + 1) * 6 + k.randFloat(-1, 1),
          T.z,
          j.ladderWidth,
          j.ladderScale,
          {
            scale: N.texStretch ? 1 : 0.02,
          },
          -O + Math.PI / 2,
          Math.PI / 2,
          k.randFloat(-0.1, 0.1),
        );
      }
      return S;
    };
    this.generateBillboard = function (N, O, P, Q, R, S) {
      var T = w.generatePlane(S, Q, {}, N, O, P);
      (T = new q.BufferGeometry().fromGeometry(T)).scale(Q, S, 1);
      T.rotateX(-Math.PI / 2);
      return T;
    };
    this.generateSign = function (N, O, P, Q, R, S, T) {
      var U = w.generatePlane(T, R, {}, O, P, Q);
      (U = new q.BufferGeometry().fromGeometry(U)).scale(R, T, 1);
      U.rotateX(-Math.PI / 2);
      return U;
    };
    this.generateFlag = function (N, O) {
      x.loadObj(
        N,
        "models/crystal_0.obj",
        "textures/crystal_0.png",
        j.flagScale,
        16777215,
        null,
        j.flagOff / 2,
      );
      var P = w.generateCube([1, 1, 0, 0, 1, 1], ...N.size, {
        scale: 1,
        amb: O,
        useScale: true,
        transparent: true,
        depthWrite: false,
        side: 2,
      });
      return (P = new q.BufferGeometry().fromGeometry(P));
    };
    this.generatePad = function (N, O) {
      x.loadObj(
        N,
        "models/pad_0.obj",
        "textures/pad_0.png",
        4,
        16777215,
        null,
        -0.5,
      );
      var P = w.generateCube([0, 0, 0, 0, 0, 0], 10, 0.5, 10, {
        scale: 1,
        amb: O,
        useScale: true,
        transparent: true,
        depthWrite: false,
        side: 2,
      });
      return (P = new q.BufferGeometry().fromGeometry(P));
    };
    this.generateWeapon = function (N, O) {
      var [P, Q, R] = N.size;
      let S = w.generateCube([1, 1, 1, 1, 1, 1], P, Q, R, {
        scale: 1,
        amb: O,
        useScale: true,
      });
      S = new q.BufferGeometry().fromGeometry(S);
      x.loadObj(
        N,
        "models/weapons/" + d[N.weaponId].src + ".obj",
        "textures/weapons/" + d[N.weaponId].src + ".png",
        d[N.weaponId].scale * 1,
        16777215,
        "wepMesh",
        -0.5,
        -1.6,
        0,
      );
      return S;
    };
    this.generateSpawn = function (N, O) {
      var P = N.cmpSpwn
        ? 16776960
        : N.team == 1
          ? 65535
          : N.team == 2
            ? 16711680
            : 16777215;
      x.loadObj(
        N,
        "models/spawn_0.obj",
        "textures/spawn_0.png",
        1,
        P,
        "spwnMesh",
        -5.5,
        0,
        (-((N.direction || 0) + 1) * Math.PI) / 2,
      );
      let Q = w.generateCube([1, 1, 1, 1, 1, 1], 7, 11, 7, {
        scale: 1,
        amb: O,
        transparent: true,
        useScale: true,
        depthWrite: false,
        side: 2,
      });
      Q = new q.BufferGeometry().fromGeometry(Q);
      return Q;
    };
    this.generateBorder = function (N, O, P) {
      var Q = new q.Geometry();
      var R = new q.SphereGeometry(0.5, 32, 32);
      var S = new q.Mesh(R);
      S.scale.set(N, O, P);
      S.updateMatrix();
      Q.merge(S.geometry, S.matrix);
      return (Q = new q.BufferGeometry().fromGeometry(Q));
    };
    this.generateGrass = function (N, O, P) {
      let Q = new q.Geometry();
      let R = Math.PI * 2 * Math.random();
      let S = new q.Mesh(w.generatePlane(N, O, {}));
      S.scale.set(N, O, P);
      S.rotateY(R * (Math.PI / 2));
      S.updateMatrix();
      Q.merge(S.geometry, S.matrix);
      let T = new q.Mesh(w.generatePlane(N, O, {}));
      T.scale.set(N, O, P);
      T.rotateY((R + 1) * (Math.PI / 2));
      T.updateMatrix();
      Q.merge(T.geometry, T.matrix);
      Q = new q.BufferGeometry().fromGeometry(Q);
      return Q;
    };
    var A = ["#969953", "#646639", "#999153"];
    var B = [
      {
        name: "Square Oak",
        height: 58,
        scales: [4, 5],
        rar: [6, 7, 8, 9, 10],
        gen: function (N, O, P, Q, R) {
          K(R.clutterMesh, N[0], N[1] + O - 1, N[2], 90, 100, 90, {
            src: "default",
            shadows: true,
            vNoise: 0.36,
            xR: P,
            coat: Q.cot,
            colr: Q.col || A[P % A.length],
          });
        },
      },
      {
        name: "Big Oak",
        height: 70,
        scales: [6, 6.2],
        rar: [5],
        gen: function (N, O, P, Q, R) {
          K(R.clutterMesh, N[0], N[1] + O - 1, N[2], 130, 100, 130, {
            src: "default",
            shadows: true,
            vNoise: 0.3,
            xR: P,
            coat: Q.cot,
            colr: Q.col || A[P % A.length],
          });
        },
      },
      {
        name: "Tall Italian",
        height: 37,
        scales: [3, 3.2],
        rar: [1, 2, 3, 4],
        gen: function (N, O, P, Q, R) {
          K(R.clutterMesh, N[0], N[1] + O - 6, N[2], 33, 80, 33, {
            src: "default",
            shadows: true,
            vNoise: 0.3,
            xR: P,
            coat: Q.cot,
            colr: Q.col || A[P % A.length],
          });
        },
      },
      {
        name: "Honey Oak",
        height: 100,
        scales: [4, 5],
        rar: [0],
        gen: function (N, O, P, Q, R) {
          K(R.clutterMesh, N[0], N[1] + O - 1, N[2], 55, 56, 55, {
            src: "default",
            shadows: true,
            vNoise: 0.35,
            xR: P,
            coat: Q.cot,
            colr: Q.col || "#616037",
          });
          J(
            R.clutterMesh,
            N[0] + 10,
            N[1] + O / 1.5 + 5,
            N[2],
            22,
            3,
            2,
            [1, 1, 1, 1, 1, 1],
            {
              src: "default",
              colr: "#665547",
              zR: 0.4,
              shadows: true,
              amb: 0.5,
            },
          );
          K(R.clutterMesh, N[0] + 20, N[1] + O / 1.5, N[2], 22, 20, 22, {
            src: "default",
            shadows: true,
            vNoise: 0.25,
            coat: Q.cot,
            colr: Q.col || "#616037",
          });
        },
      },
    ];
    this.addTREE = function (N, O, P) {
      var Q = Math.round(Math.abs((N[0] + N[2]) % 10));
      for (var R = 0; R < B.length; ++R) {
        if (B[R].rar.indexOf(Q) >= 0) {
          tmpTree = B[R];
          break;
        }
      }
      if (tmpTree) {
        var S = tmpTree.height - Q * 2;
        var T = tmpTree.scales[Q % tmpTree.scales.length];
        J(P.clutterMesh, N[0], N[1], N[2], T, S + 20, T, [1, 1, 0, 0, 1, 1], {
          src: "default",
          colr: "#665547",
          shadows: true,
          amb: 0.5,
        });
        tmpTree.gen(N, S, Q, O, P);
      }
    };
    this.addSTUMP = function (N, O, P) {
      J(P.clutterMesh, N[0], N[1], N[2], 4, 80, 4, [1, 1, 1, 0, 1, 1], {
        src: "default",
        colr: "#665547",
        shadows: true,
        amb: 0.5,
      });
      J(
        P.clutterMesh,
        N[0],
        N[1] + 30,
        N[2] + 10,
        2,
        3,
        22,
        [1, 1, 1, 1, 1, 1],
        {
          src: "default",
          colr: "#665547",
          yR: -0.5,
          shadows: true,
          amb: 0.5,
        },
      );
      J(
        P.clutterMesh,
        N[0] + 10,
        N[1] + 50,
        N[2],
        22,
        3,
        2,
        [1, 1, 1, 1, 1, 1],
        {
          src: "default",
          colr: "#665547",
          zR: 0.4,
          shadows: true,
          amb: 0.5,
        },
      );
    };
    this.addBUSH = function (N, O, P) {
      var Q = N[3];
      var R = Math.round(Math.abs((N[0] + N[2]) % 10));
      var S = Q == 2 ? 0.5 : 1;
      K(P.clutterMesh, N[0], N[1] - S * 6, N[2], S * 29, S * 21, S * 28, {
        src: "default",
        colr: O.col || "#646639",
        vNoise: 0.3,
        coat: O.cot,
        xR: R,
        shadows: true,
      });
    };
    this.addGRASS = function (N, O, P, Q) {};
    this.addLOOT = function (N, O, P) {
      var Q = Math.round(Math.abs((N[0] + N[2]) % 3));
      J(
        P.clutterMesh,
        N[0] + 6,
        N[1],
        N[2] + 15,
        18,
        1,
        3,
        [1, 1, 1, 0, 1, 1],
        {
          src: "default",
          colr: "#665547",
          xR: 0.86,
          shadows: true,
          amb: 0.5,
        },
      );
      if (Q == 0 || Q == 1) {
        L(P.clutterMesh, N[0], N[1], N[2], 7, 7, 9, {
          src: "default",
          colr: "#9e2b2b",
          shadows: true,
        });
      }
      if (Q == 2 || Q == 1) {
        L(P.clutterMesh, N[0] - 7, N[1], N[2] + 12, 7, 7, 9, {
          src: "default",
          colr: "#2b769e",
          shadows: true,
        });
      }
    };
    var C = [
      {
        scl: 25,
        hei: 20,
        nois: 0.2,
        col: "#707070",
      },
      {
        scl: 50,
        hei: 30,
        nois: 0.3,
        col: "#545454",
      },
      {
        scl: 13,
        hei: 10,
        nois: 0.15,
        col: "#707070",
        noCol: true,
      },
      {
        scl: 10,
        hei: 10,
        nois: 0.1,
        col: "#545454",
        noCol: true,
      },
    ];
    this.addROCK = function (N, O, P) {
      var Q = N[1] - 7;
      var R = Math.round(Math.abs((N[0] + N[2]) % 10));
      var S = C[R % C.length];
      K(P.clutterMesh, N[0], Q, N[2], S.scl, S.hei, S.scl, {
        src: "default",
        colr: S.col,
        vNoise: S.nois,
        noAmb: true,
        coat: O.cot,
        shadows: true,
      });
    };
    this.addTerrObj = function (N, O, P, Q) {
      var R = {
        col: null,
        cot: null,
      };
      var S = P.BIOME_INDEXES[N[3]];
      var T = P.MAP_OBJS[O];
      if (T && S) {
        if (T.biomeCoats && T.biomeCoats[S]) {
          R.cot = T.biomeCoats[S];
        }
        if (T.biomeCols && T.biomeCols[S]) {
          R.col = T.biomeCols[S][k.randInt(0, T.biomeCols[S].length - 1)];
        }
      }
      x["add" + O](N, R, P, Q);
    };
    let M = (N) => ({
      src: N,
    });
    this.getImageTexture = (N) => {
      var O = new q.Texture(N);
      O.wrapS = q.RepeatWrapping;
      O.wrapT = q.RepeatWrapping;
      O.repeat.set(1, 1);
      O.minFilter = q.NearestFilter;
      O.magFilter = q.NearestFilter;
      O.needsUpdate = true;
      return O;
    };
    var D = [];
    this.loadTexturePrefab = function (N, O = null) {
      if (O.prefab.hasText) {
        O.defaultMaterial.map = x.getImageTexture(
          k.createCanvasText(
            O.size[0],
            O.size[2],
            O.text || "Hello World",
            O.fsize || 10,
            O.fcolor || "#000",
            O.bcolor || "#fff",
            !O.backVisible,
            O.tAlign || 0,
          ),
        );
      } else if (
        O.texturePrefab.src ||
        (O.assetTexture && O.prefab.assetTextures)
      ) {
        let Q = O.assetTexture && O.prefab.assetTextures;
        let R = Q ? M(O.assetTexture + "/texture") : x.getTextureByName(N);
        R =
          O.objType == "BILLBOARD"
            ? M("pubs/b_" + (O.poster || k.randInt(1, j.billboardCnt)))
            : R;
        R = O.objType == "FLAG" ? M("zone_r") : R;
        R =
          O.objType == "LIGHT_CONE"
            ? M("lightcone_" + (O.fullcone ? 1 : 0))
            : R;
        R = O.objType == "SPECTATE_CAM" ? M("spectatecam_0") : R;
        R = O.objType == "RUNE" ? M("rune_0") : R;
        if (R.src == "default") {
          return (O.defaultMaterial.map = undefined);
        }
        if (D[R.src]) {
          O.defaultMaterial.map = D[R.src].clone();
          O.defaultMaterial.map.needsUpdate = true;
          O.defaultMaterial.map.offset.x = O.texOffX || 0;
          O.defaultMaterial.map.offset.y = O.texOffY || 0;
          O.defaultMaterial.needsUpdate = true;
        } else if (R.src.startsWith("custom_")) {
          var P = new q.Texture(x.missingTexture);
          P.wrapS = q.RepeatWrapping;
          P.wrapT = q.RepeatWrapping;
          P.repeat.set(1, 1);
          P.minFilter = R.filter || q.NearestFilter;
          P.magFilter = R.filter || q.NearestFilter;
          P.offset.x = O.texOffX || 0;
          P.offset.y = O.texOffY || 0;
          P.needsUpdate = true;
          D[R.src] = P;
          O.defaultMaterial.map = P;
          O.defaultMaterial.needsUpdate = true;
        } else {
          E.load(
            Q
              ? k.userAssetsUrl(R.src + ".png")
              : k.assetsUrl("/textures/" + R.src + ".png"),
            (S) => {
              S.wrapS = q.RepeatWrapping;
              S.wrapT = q.RepeatWrapping;
              S.repeat.set(1, 1);
              S.minFilter = R.filter || q.NearestFilter;
              S.magFilter = R.filter || q.NearestFilter;
              S.offset.x = O.texOffX || 0;
              S.offset.y = O.texOffY || 0;
              S.needsUpdate = true;
              D[R.src] = S;
              O.defaultMaterial.map = S;
              O.defaultMaterial.needsUpdate = true;
            },
            undefined,
            function () {
              var S = new q.Texture(x.missingTexture);
              S.wrapS = q.RepeatWrapping;
              S.wrapT = q.RepeatWrapping;
              S.repeat.set(1, 1);
              S.minFilter = R.filter || q.NearestFilter;
              S.magFilter = R.filter || q.NearestFilter;
              S.offset.x = O.texOffX || 0;
              S.offset.y = O.texOffY || 0;
              S.needsUpdate = true;
              D[R.src] = S;
              O.defaultMaterial.map = S;
              O.defaultMaterial.needsUpdate = true;
            },
          );
        }
      } else {
        O.defaultMaterial.map = undefined;
      }
    };
    this.missingTexture = new Image();
    this.missingTexture.src =
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAACAgMAAAAP2OW3AAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAxQTFRF/wDbAAAAAAAA/wDbC5gN/AAAAAR0Uk5T/P/9/02rixUAAAAMSURBVHicYxBg2AAAAOQAwSeo6FcAAAAASUVORK5CYII=";
  }
};
